/* @ds-bundle: {"format":3,"namespace":"RideYourArtDesignSystem_221a9a","components":[{"name":"ProductCard","sourcePath":"components/commerce/ProductCard.jsx"},{"name":"Badge","sourcePath":"components/core/Badge.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Card","sourcePath":"components/core/Card.jsx"},{"name":"Chip","sourcePath":"components/core/Chip.jsx"},{"name":"Input","sourcePath":"components/core/Input.jsx"},{"name":"Rating","sourcePath":"components/core/Rating.jsx"}],"sourceHashes":{"components/commerce/ProductCard.jsx":"6ad454555534","components/core/Badge.jsx":"a03fc98e40ff","components/core/Button.jsx":"99a75bfa93af","components/core/Card.jsx":"09059f36b70e","components/core/Chip.jsx":"a68579f5e5d7","components/core/Input.jsx":"c1c915c80ee1","components/core/Rating.jsx":"adbc87790851","ui_kits/storefront/Board.jsx":"d36ea018fec3","ui_kits/storefront/CartDrawer.jsx":"b1f2e3634166","ui_kits/storefront/Footer.jsx":"99a7fb0395b9","ui_kits/storefront/Header.jsx":"4951e327d72e","ui_kits/storefront/Home.jsx":"548429513818","ui_kits/storefront/Icons.jsx":"0e35eba630e0","ui_kits/storefront/ProductDetail.jsx":"f15d9ab0aa24","ui_kits/storefront/Shop.jsx":"84d4483cc99d","ui_kits/storefront/data.js":"0f5badb773df"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.RideYourArtDesignSystem_221a9a = window.RideYourArtDesignSystem_221a9a || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/core/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — Badge
 * Small status/marketing pill. Use for "Neu", "Bestseller", sale flags.
 */
function Badge({
  tone = "coral",
  children,
  style = {},
  ...rest
}) {
  const tones = {
    coral: {
      background: "var(--accent)",
      color: "var(--text-on-coral)"
    },
    apricot: {
      background: "var(--rya-apricot)",
      color: "var(--rya-olive-700)"
    },
    olive: {
      background: "var(--rya-olive)",
      color: "var(--rya-cream)"
    },
    soft: {
      background: "var(--accent-soft)",
      color: "var(--accent-press)"
    },
    sand: {
      background: "var(--rya-sand)",
      color: "var(--rya-olive-700)"
    }
  };
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: "5px",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--fw-bold)",
      fontSize: "var(--text-xs)",
      letterSpacing: "var(--ls-wide)",
      textTransform: "uppercase",
      padding: "5px 11px",
      borderRadius: "var(--radius-pill)",
      lineHeight: 1,
      ...tones[tone],
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Badge.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — Button
 * Fully-rounded (pill) button in brand coral, with secondary/ghost/inverse
 * variants and three sizes. Gentle spring press.
 */
function Button({
  variant = "primary",
  size = "md",
  full = false,
  disabled = false,
  iconLeft = null,
  iconRight = null,
  children,
  style = {},
  ...rest
}) {
  const sizes = {
    sm: {
      padding: "8px 16px",
      fontSize: "14px",
      gap: "6px"
    },
    md: {
      padding: "12px 24px",
      fontSize: "15px",
      gap: "8px"
    },
    lg: {
      padding: "16px 32px",
      fontSize: "17px",
      gap: "10px"
    }
  };
  const variants = {
    primary: {
      background: "var(--accent)",
      color: "var(--text-on-coral)",
      border: "var(--border-width) solid var(--accent)",
      boxShadow: "var(--shadow-coral)"
    },
    secondary: {
      background: "var(--surface-card)",
      color: "var(--text-strong)",
      border: "var(--border-width) solid var(--border-strong)",
      boxShadow: "var(--shadow-xs)"
    },
    ghost: {
      background: "transparent",
      color: "var(--accent-press)",
      border: "var(--border-width) solid transparent",
      boxShadow: "none"
    },
    inverse: {
      background: "var(--rya-cream)",
      color: "var(--rya-olive)",
      border: "var(--border-width) solid var(--rya-cream)",
      boxShadow: "none"
    }
  };
  const base = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: sizes[size].gap,
    fontFamily: "var(--font-body)",
    fontWeight: "var(--fw-bold)",
    lineHeight: 1,
    borderRadius: "var(--radius-pill)",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.45 : 1,
    width: full ? "100%" : "auto",
    transition: "transform var(--dur-fast) var(--ease-spring), background var(--dur-fast) var(--ease-out), filter var(--dur-fast) var(--ease-out)",
    ...sizes[size],
    ...variants[variant],
    ...style
  };
  const onDown = e => {
    if (!disabled) e.currentTarget.style.transform = "scale(0.96)";
  };
  const onUp = e => {
    e.currentTarget.style.transform = "scale(1)";
  };
  const onEnter = e => {
    if (disabled) return;
    if (variant === "primary") e.currentTarget.style.background = "var(--accent-hover)";else e.currentTarget.style.filter = "brightness(0.97)";
  };
  const onLeave = e => {
    e.currentTarget.style.transform = "scale(1)";
    e.currentTarget.style.filter = "none";
    if (variant === "primary") e.currentTarget.style.background = "var(--accent)";
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    disabled: disabled,
    style: base,
    onMouseDown: onDown,
    onMouseUp: onUp,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave
  }, rest), iconLeft, children, iconRight);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — Card
 * Soft white panel with generous rounding and a warm low shadow.
 * `hoverable` adds a gentle lift. `tone` switches to sunken/inverse.
 */
function Card({
  tone = "card",
  hoverable = false,
  padding = "lg",
  children,
  style = {},
  ...rest
}) {
  const tones = {
    card: {
      background: "var(--surface-card)",
      color: "var(--text-body)",
      border: "1px solid var(--border-soft)"
    },
    sunken: {
      background: "var(--surface-sunken)",
      color: "var(--text-body)",
      border: "1px solid var(--border-soft)"
    },
    inverse: {
      background: "var(--surface-inverse)",
      color: "var(--text-inverse)",
      border: "1px solid transparent"
    }
  };
  const pads = {
    none: "0",
    sm: "var(--space-4)",
    lg: "var(--space-5)",
    xl: "var(--space-6)"
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      borderRadius: "var(--radius-lg)",
      padding: pads[padding],
      boxShadow: "var(--shadow-sm)",
      transition: "transform var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out)",
      ...tones[tone],
      ...style
    },
    onMouseEnter: e => {
      if (!hoverable) return;
      e.currentTarget.style.transform = "translateY(-4px)";
      e.currentTarget.style.boxShadow = "var(--shadow-lg)";
    },
    onMouseLeave: e => {
      if (!hoverable) return;
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "var(--shadow-sm)";
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Card.jsx", error: String((e && e.message) || e) }); }

// components/core/Chip.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — Chip
 * Selectable filter pill (collections, surfaces, sizes). Coral when active.
 */
function Chip({
  active = false,
  children,
  onClick,
  style = {},
  ...rest
}) {
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    onClick: onClick,
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: "var(--fw-semibold)",
      fontSize: "var(--text-sm)",
      padding: "8px 16px",
      borderRadius: "var(--radius-pill)",
      cursor: "pointer",
      lineHeight: 1,
      transition: "all var(--dur-fast) var(--ease-out)",
      background: active ? "var(--accent)" : "var(--surface-card)",
      color: active ? "var(--text-on-coral)" : "var(--text-body)",
      border: `var(--border-width) solid ${active ? "var(--accent)" : "var(--border-strong)"}`,
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Chip });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Chip.jsx", error: String((e && e.message) || e) }); }

// components/core/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — Input
 * Soft, rounded text field on a warm surface with a label and optional hint.
 */
function Input({
  label,
  hint,
  error,
  type = "text",
  id,
  style = {},
  ...rest
}) {
  const inputId = id || `rya-input-${Math.random().toString(36).slice(2, 8)}`;
  const [focused, setFocused] = React.useState(false);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      fontFamily: "var(--font-body)"
    }
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    style: {
      fontSize: "var(--text-sm)",
      fontWeight: "var(--fw-semibold)",
      color: "var(--text-strong)"
    }
  }, label), /*#__PURE__*/React.createElement("input", _extends({
    id: inputId,
    type: type,
    onFocus: e => {
      setFocused(true);
      rest.onFocus && rest.onFocus(e);
    },
    onBlur: e => {
      setFocused(false);
      rest.onBlur && rest.onBlur(e);
    },
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "var(--text-base)",
      color: "var(--text-strong)",
      background: "var(--surface-card)",
      border: `var(--border-width) solid ${error ? "var(--danger)" : focused ? "var(--accent)" : "var(--border-strong)"}`,
      borderRadius: "var(--radius-md)",
      padding: "12px 16px",
      outline: "none",
      boxShadow: focused ? "0 0 0 4px var(--accent-soft)" : "none",
      transition: "border var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out)",
      ...style
    }
  }, rest)), (hint || error) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "var(--text-xs)",
      color: error ? "var(--danger)" : "var(--text-muted)"
    }
  }, error || hint));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Input.jsx", error: String((e && e.message) || e) }); }

// components/core/Rating.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — Rating
 * Five-star row in coral. Read-only display of a review score.
 */
function Rating({
  value = 5,
  count = null,
  size = 16,
  style = {},
  ...rest
}) {
  const Star = ({
    fill
  }) => /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: `g${fill}`
  }, /*#__PURE__*/React.createElement("stop", {
    offset: `${fill * 100}%`,
    stopColor: "var(--accent)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: `${fill * 100}%`,
    stopColor: "var(--border-strong)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5l2.9 5.9 6.5.95-4.7 4.58 1.1 6.47L12 17.4l-5.8 3.05 1.1-6.47-4.7-4.58 6.5-.95z",
    fill: `url(#g${fill})`
  }));
  const stars = Array.from({
    length: 5
  }, (_, i) => {
    const f = Math.max(0, Math.min(1, value - i));
    return /*#__PURE__*/React.createElement(Star, {
      key: i,
      fill: f
    });
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      fontFamily: "var(--font-body)",
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      gap: "1px"
    }
  }, stars), count != null && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "var(--text-sm)",
      color: "var(--text-muted)",
      fontWeight: "var(--fw-semibold)"
    }
  }, value.toFixed(1), " \xB7 ", count));
}
Object.assign(__ds_scope, { Rating });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Rating.jsx", error: String((e && e.message) || e) }); }

// components/commerce/ProductCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — ProductCard
 * Balance-board product tile: art image, name, price-from, rating and an
 * optional flag badge. Lifts gently on hover; coral "in den Warenkorb" affordance.
 */
function ProductCard({
  name,
  price,
  image = null,
  artStyle = {},
  badge = null,
  rating = null,
  reviews = null,
  onClick,
  style = {},
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    onClick: onClick,
    style: {
      display: "flex",
      flexDirection: "column",
      background: "var(--surface-card)",
      borderRadius: "var(--radius-lg)",
      overflow: "hidden",
      border: "1px solid var(--border-soft)",
      cursor: onClick ? "pointer" : "default",
      transition: "transform var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out)",
      boxShadow: "var(--shadow-xs)",
      fontFamily: "var(--font-body)",
      ...style
    },
    onMouseEnter: e => {
      e.currentTarget.style.transform = "translateY(-6px)";
      e.currentTarget.style.boxShadow = "var(--shadow-lg)";
    },
    onMouseLeave: e => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "var(--shadow-xs)";
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      aspectRatio: "4 / 5",
      background: "var(--surface-sunken)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden"
    }
  }, badge && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: "12px",
      left: "12px",
      zIndex: 2
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Badge, {
    tone: "coral"
  }, badge)), image ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: name,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      padding: "14px"
    }
  }) :
  /*#__PURE__*/
  // Fallback: abstract "board art" using brand colors
  React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      ...artStyle
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "var(--space-4)",
      display: "flex",
      flexDirection: "column",
      gap: "6px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: "var(--fw-bold)",
      fontSize: "var(--text-h3)",
      color: "var(--text-strong)",
      lineHeight: 1.1
    }
  }, name), rating != null && /*#__PURE__*/React.createElement(__ds_scope.Rating, {
    value: rating,
    count: reviews,
    size: 14
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "2px",
      fontWeight: "var(--fw-bold)",
      color: "var(--text-strong)",
      fontSize: "var(--text-body-lg)"
    }
  }, "Von ", price)));
}
Object.assign(__ds_scope, { ProductCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/ProductCard.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/Board.jsx
try { (() => {
/* global React */
// Ride Your Art — the balance board, rendered as wall art.
// A rounded board panel (the art) with a cork/wood rim and a soft wall shadow.

function Board({
  art,
  shape = "portrait",
  float = false,
  style = {}
}) {
  const dims = shape === "wide" ? {
    width: "100%",
    aspectRatio: "2.4 / 1",
    borderRadius: "120px"
  } : {
    width: "62%",
    aspectRatio: "1 / 2.1",
    borderRadius: "140px"
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...dims,
      background: art,
      boxShadow: "0 24px 50px rgba(44,42,38,.28), inset 0 0 0 6px rgba(255,251,246,.55), inset 0 2px 12px rgba(255,255,255,.25)",
      position: "relative",
      transform: float ? "rotate(-4deg)" : "none",
      transition: "transform var(--dur-slow) var(--ease-spring)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      borderRadius: "inherit",
      background: "linear-gradient(135deg, rgba(255,255,255,.35) 0%, rgba(255,255,255,0) 38%)"
    }
  })));
}
window.Board = Board;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/Board.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/CartDrawer.jsx
try { (() => {
/* global React */
// Ride Your Art — slide-in cart drawer.

function CartDrawer({
  open,
  items,
  onClose,
  onQty
}) {
  const {
    Button
  } = window.RideYourArtDesignSystem_221a9a;
  const {
    Icon
  } = window;
  const parsePrice = s => parseFloat(s.replace(/[^0-9,]/g, "").replace(",", "."));
  const subtotal = items.reduce((sum, it) => sum + parsePrice(it.price) * it.qty, 0);
  const fmt = n => "€" + n.toFixed(2).replace(".", ",");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: "fixed",
      inset: 0,
      background: "rgba(44,42,38,.4)",
      opacity: open ? 1 : 0,
      pointerEvents: open ? "auto" : "none",
      transition: "opacity var(--dur-base) var(--ease-out)",
      zIndex: 60
    }
  }), /*#__PURE__*/React.createElement("aside", {
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      width: "min(420px, 92vw)",
      background: "var(--surface-page)",
      zIndex: 61,
      transform: open ? "translateX(0)" : "translateX(100%)",
      transition: "transform var(--dur-base) var(--ease-out)",
      display: "flex",
      flexDirection: "column",
      boxShadow: "var(--shadow-lg)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "20px 24px",
      borderBottom: "1px solid var(--border-soft)"
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontSize: "22px"
    }
  }, "Einkaufswagen"), /*#__PURE__*/React.createElement("button", {
    className: "rya-iconbtn",
    onClick: onClose,
    "aria-label": "Schlie\xDFen"
  }, /*#__PURE__*/React.createElement(Icon.x, {
    size: 20
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflowY: "auto",
      padding: "16px 24px"
    }
  }, items.length === 0 ? /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--text-muted)",
      textAlign: "center",
      marginTop: "40px"
    }
  }, "Dein Einkaufswagen ist im Moment leer.") : items.map(it => /*#__PURE__*/React.createElement("div", {
    key: it.id,
    style: {
      display: "flex",
      gap: "14px",
      padding: "14px 0",
      borderBottom: "1px solid var(--border-soft)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "56px",
      height: "72px",
      borderRadius: "var(--radius-sm)",
      background: it.art,
      flex: "none",
      boxShadow: "var(--shadow-xs)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 700,
      color: "var(--text-strong)",
      fontFamily: "var(--font-display)",
      fontSize: "18px"
    }
  }, it.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "13px",
      color: "var(--text-muted)",
      marginBottom: "8px"
    }
  }, "Kork \xB7 MAGIC MOUNT"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: "10px",
      border: "1.5px solid var(--border-strong)",
      borderRadius: "var(--radius-pill)",
      padding: "4px 10px"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => onQty(it.id, -1),
    style: {
      background: "none",
      border: "none",
      cursor: "pointer",
      display: "flex",
      color: "var(--text-body)"
    }
  }, /*#__PURE__*/React.createElement(Icon.minus, {
    size: 15
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 700,
      minWidth: "16px",
      textAlign: "center"
    }
  }, it.qty), /*#__PURE__*/React.createElement("button", {
    onClick: () => onQty(it.id, 1),
    style: {
      background: "none",
      border: "none",
      cursor: "pointer",
      display: "flex",
      color: "var(--text-body)"
    }
  }, /*#__PURE__*/React.createElement(Icon.plus, {
    size: 15
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: "auto",
      fontWeight: 700,
      color: "var(--text-strong)"
    }
  }, it.price)))))), items.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "20px 24px",
      borderTop: "1px solid var(--border-soft)",
      background: "var(--surface-card)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "4px",
      fontSize: "16px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--text-muted)"
    }
  }, "Zwischensumme"), /*#__PURE__*/React.createElement("strong", {
    style: {
      color: "var(--text-strong)"
    }
  }, fmt(subtotal))), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "12px",
      color: "var(--text-muted)",
      margin: "0 0 14px"
    }
  }, "Versand & Steuern werden an der Kasse berechnet."), /*#__PURE__*/React.createElement(Button, {
    full: true,
    size: "lg",
    iconRight: /*#__PURE__*/React.createElement(Icon.arrowRight, {
      size: 18
    })
  }, "Zur Kasse"))));
}
window.CartDrawer = CartDrawer;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/CartDrawer.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/Footer.jsx
try { (() => {
/* global React */
// Ride Your Art — site footer.

function Footer({
  onNav
}) {
  const {
    Icon
  } = window;
  const cols = [{
    h: "Infos",
    links: ["AGB", "Impressum", "Widerruf", "Kontakt", "Versand & Retouren"]
  }, {
    h: "Mehr von uns",
    links: ["Kund*innen Stimmen", "Blog", "Über uns"]
  }];
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: "var(--rya-charcoal)",
      color: "var(--rya-sand)",
      padding: "clamp(40px,5vw,72px) clamp(16px,4vw,48px) 28px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1100px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "1.4fr 1fr 1fr 1.2fr",
      gap: "32px"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/logo-wordmark-cream.svg",
    alt: "Ride Your Art",
    style: {
      width: "150px",
      marginBottom: "16px"
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "14px",
      maxWidth: "240px",
      lineHeight: 1.6
    }
  }, "Mehr Bewegung und Kunst in dein Leben. Handgefertigt in \xD6sterreich. \uD83C\uDDE6\uD83C\uDDF9"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "10px",
      marginTop: "16px"
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "rya-iconbtn rya-iconbtn--dark",
    "aria-label": "Instagram"
  }, /*#__PURE__*/React.createElement(Icon.instagram, {
    size: 18
  })), /*#__PURE__*/React.createElement("button", {
    className: "rya-iconbtn rya-iconbtn--dark",
    "aria-label": "Pinterest"
  }, /*#__PURE__*/React.createElement(Icon.sparkles, {
    size: 18
  })))), cols.map(c => /*#__PURE__*/React.createElement("div", {
    key: c.h
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 800,
      color: "var(--rya-cream)",
      marginBottom: "14px",
      fontSize: "15px"
    }
  }, c.h), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: "10px"
    }
  }, c.links.map(l => /*#__PURE__*/React.createElement("li", {
    key: l
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => e.preventDefault(),
    style: {
      color: "var(--rya-sand)",
      fontSize: "14px"
    }
  }, l)))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 800,
      color: "var(--rya-cream)",
      marginBottom: "14px",
      fontSize: "15px"
    }
  }, "Du hast Fragen?"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "14px",
      lineHeight: 1.6
    }
  }, "Melde dich einfach bei ", /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => e.preventDefault(),
    style: {
      color: "var(--rya-apricot)"
    }
  }, "move@rideyourart.com"), " oder auf Instagram \uD83D\uDE0A"))), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1100px",
      margin: "32px auto 0",
      paddingTop: "20px",
      borderTop: "1px solid rgba(255,232,214,.12)",
      fontSize: "13px",
      color: "var(--rya-stone)"
    }
  }, "\xA9 2026 Ride Your Art"));
}
window.Footer = Footer;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/Footer.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/Header.jsx
try { (() => {
/* global React */
// Ride Your Art — site header with promo bar, logo, nav, cart.

function Header({
  cartCount,
  onNav,
  onCart,
  active
}) {
  const {
    Icon
  } = window;
  const navItems = [{
    id: "custom",
    label: "Dein Custom Board"
  }, {
    id: "shop",
    label: "Shop"
  }, {
    id: "about",
    label: "Über uns"
  }, {
    id: "reviews",
    label: "Bewertungen"
  }];
  return /*#__PURE__*/React.createElement("header", {
    style: {
      position: "sticky",
      top: 0,
      zIndex: 40
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--rya-olive)",
      color: "var(--rya-cream)",
      textAlign: "center",
      fontSize: "13px",
      fontWeight: 600,
      padding: "8px 16px",
      letterSpacing: ".01em"
    }
  }, "Versandkostenfrei ab 50\u20AC \uD83C\uDDE6\uD83C\uDDF9 & \uD83C\uDDE9\uD83C\uDDEA"), /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--surface-page)",
      borderBottom: "1px solid var(--border-soft)",
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      alignItems: "center",
      padding: "14px clamp(16px, 4vw, 48px)"
    }
  }, /*#__PURE__*/React.createElement("nav", {
    style: {
      display: "flex",
      gap: "22px"
    }
  }, navItems.map(n => /*#__PURE__*/React.createElement("button", {
    key: n.id,
    onClick: () => onNav(n.id),
    style: {
      background: "none",
      border: "none",
      cursor: "pointer",
      fontFamily: "var(--font-body)",
      fontSize: "15px",
      fontWeight: active === n.id ? 800 : 600,
      color: active === n.id ? "var(--accent-press)" : "var(--text-body)",
      padding: "4px 0",
      whiteSpace: "nowrap"
    }
  }, n.label))), /*#__PURE__*/React.createElement("button", {
    onClick: () => onNav("home"),
    style: {
      background: "none",
      border: "none",
      cursor: "pointer",
      justifySelf: "center"
    },
    "aria-label": "Ride Your Art \u2014 Startseite"
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/logo-wordmark-coral.svg",
    alt: "Ride Your Art",
    style: {
      height: "52px",
      display: "block"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "8px",
      justifyContent: "flex-end",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "rya-iconbtn",
    "aria-label": "Suchen"
  }, /*#__PURE__*/React.createElement(Icon.search, {
    size: 20
  })), /*#__PURE__*/React.createElement("button", {
    className: "rya-iconbtn",
    "aria-label": "Merkliste"
  }, /*#__PURE__*/React.createElement(Icon.heart, {
    size: 20
  })), /*#__PURE__*/React.createElement("button", {
    className: "rya-iconbtn",
    "aria-label": "Warenkorb",
    onClick: onCart,
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement(Icon.bag, {
    size: 20
  }), cartCount > 0 && /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: "-2px",
      right: "-2px",
      background: "var(--accent)",
      color: "#fff",
      fontSize: "11px",
      fontWeight: 800,
      minWidth: "18px",
      height: "18px",
      borderRadius: "999px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 4px"
    }
  }, cartCount)))));
}
window.Header = Header;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/Header.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/Home.jsx
try { (() => {
/* global React */
// Ride Your Art — Home page sections.

function Home({
  onNav,
  onAdd,
  onOpenProduct
}) {
  const {
    Button,
    Badge,
    Rating,
    ProductCard,
    Chip,
    Input
  } = window.RideYourArtDesignSystem_221a9a;
  const {
    Icon,
    Board
  } = window;
  const D = window.RYA_DATA;
  const bestsellers = D.products.slice(0, 4);
  return /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement("section", {
    style: {
      background: "linear-gradient(180deg, var(--surface-page) 0%, #FBDDD3 100%)",
      padding: "clamp(40px,6vw,90px) clamp(16px,4vw,48px) 0",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1200px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "1.1fr .9fr",
      gap: "40px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "rya-eyebrow"
  }, "Balance Boards & Wandkunst"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: "clamp(48px,7vw,84px)",
      lineHeight: ".98",
      margin: "14px 0 18px",
      color: "var(--text-strong)"
    }
  }, "Art That", /*#__PURE__*/React.createElement("br", null), "Moves You"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "19px",
      maxWidth: "440px",
      color: "var(--text-body)",
      marginBottom: "28px"
    }
  }, "Hol dir dein Custom Board. Jedes Board kommt mit der ", /*#__PURE__*/React.createElement("strong", null, "MAGIC\xA0MOUNT"), " \u2014 so h\xE4ngst du es direkt als Wandbild auf."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    iconRight: /*#__PURE__*/React.createElement(Icon.arrowRight, {
      size: 18
    }),
    onClick: () => onNav("custom")
  }, "Hol dir dein Board"), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    variant: "ghost",
    onClick: () => onNav("shop")
  }, "Alle Designs")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginTop: "28px"
    }
  }, /*#__PURE__*/React.createElement(Rating, {
    value: 4.9,
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "14px",
      color: "var(--text-muted)",
      fontWeight: 600
    }
  }, "4,9 / 5 \xB7 \xFCber 900 Bewegte"))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: "min(56vw, 520px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: D.products[4].image,
    alt: D.products[4].name,
    style: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      transform: "rotate(-4deg)",
      filter: "drop-shadow(0 24px 40px rgba(44,42,38,.28))"
    }
  })))), /*#__PURE__*/React.createElement("section", {
    style: {
      padding: "clamp(48px,6vw,88px) clamp(16px,4vw,48px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1200px",
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "rya-eyebrow"
  }, "Unsere Kollektionen"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: "clamp(30px,4vw,44px)",
      margin: "10px 0 28px"
    }
  }, "Such dir deinen Vibe"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px"
    }
  }, [{
    c: D.collections[0],
    art: D.products[0].art,
    sub: "Floral, organisch, warm"
  }, {
    c: D.collections[1],
    art: D.products[3].art,
    sub: "Berge, Seen, Wälder"
  }].map(({
    c,
    art,
    sub
  }) => /*#__PURE__*/React.createElement("button", {
    key: c.id,
    onClick: () => onNav("shop"),
    style: {
      position: "relative",
      border: "none",
      cursor: "pointer",
      borderRadius: "var(--radius-lg)",
      overflow: "hidden",
      aspectRatio: "16/9",
      background: art,
      padding: "28px",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      color: "#fff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(180deg, rgba(44,42,38,0) 35%, rgba(44,42,38,.55) 100%)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: "30px"
    }
  }, c.label), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "15px",
      opacity: .9
    }
  }, sub))))))), /*#__PURE__*/React.createElement("section", {
    style: {
      padding: "0 clamp(16px,4vw,48px) clamp(48px,6vw,88px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1200px",
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: "clamp(28px,3.5vw,38px)",
      margin: 0
    }
  }, "Unsere beliebtesten Boards"), /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    iconRight: /*#__PURE__*/React.createElement(Icon.arrowRight, {
      size: 18
    }),
    onClick: () => onNav("shop")
  }, "Alle ansehen")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      gap: "20px"
    }
  }, bestsellers.map(p => /*#__PURE__*/React.createElement(ProductCard, {
    key: p.id,
    name: p.name,
    price: p.price,
    badge: p.badge,
    rating: p.rating,
    reviews: p.reviews,
    image: p.image,
    artStyle: {
      background: p.art
    },
    onClick: () => onOpenProduct(p)
  }))))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--rya-olive)",
      color: "var(--rya-cream)",
      padding: "clamp(48px,6vw,88px) clamp(16px,4vw,48px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1100px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: ".9fr 1.1fr",
      gap: "48px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "min(60vw, 420px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: D.products[1].image,
    alt: D.products[1].name,
    style: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      filter: "drop-shadow(0 24px 40px rgba(0,0,0,.35))"
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "rya-eyebrow",
    style: {
      color: "var(--rya-apricot)"
    }
  }, "Art? Yeah, ART!"), /*#__PURE__*/React.createElement("h2", {
    style: {
      color: "var(--rya-cream)",
      fontSize: "clamp(30px,4vw,46px)",
      margin: "12px 0 16px"
    }
  }, "Die MAGIC MOUNT"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--rya-sand)",
      fontSize: "18px",
      maxWidth: "460px",
      marginBottom: "24px"
    }
  }, "Mit der magnetischen Wandhalterung wird dein Balance Board im Handumdrehen zum Wandbild. Eyecatcher in jedem Raum. Garantiert!"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      marginBottom: "28px"
    }
  }, ["Magnetisch — kein Werkzeug nötig", "Schont Board & Wand", "In Sekunden abgehängt fürs Workout"].map(t => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "16px",
      color: "var(--rya-cream)"
    }
  }, /*#__PURE__*/React.createElement(Icon.check, {
    size: 18,
    style: {
      color: "var(--rya-apricot)"
    }
  }), " ", t))), /*#__PURE__*/React.createElement(Button, {
    variant: "inverse",
    iconRight: /*#__PURE__*/React.createElement(Icon.arrowRight, {
      size: 18
    }),
    onClick: () => onNav("shop")
  }, "Hol dir Kunst nach Hause \uD83C\uDFC4\uD83C\uDFFC")))), /*#__PURE__*/React.createElement("section", {
    style: {
      padding: "clamp(48px,6vw,88px) clamp(16px,4vw,48px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1100px",
      margin: "0 auto",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: "clamp(28px,3.5vw,40px)",
      margin: "0 0 8px"
    }
  }, "Das sagen unsere Kunden \uD83D\uDE0D"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--text-muted)",
      marginBottom: "36px"
    }
  }, "\xDCber 900 Menschen bewegen sich mit ihrem Board."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(3,1fr)",
      gap: "20px"
    }
  }, D.reviews.map(r => /*#__PURE__*/React.createElement("div", {
    key: r.name,
    style: {
      background: "var(--surface-card)",
      border: "1px solid var(--border-soft)",
      borderRadius: "var(--radius-lg)",
      padding: "26px",
      textAlign: "left",
      boxShadow: "var(--shadow-sm)"
    }
  }, /*#__PURE__*/React.createElement(Rating, {
    value: r.rating,
    size: 16
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "14px 0 18px",
      fontSize: "16px",
      color: "var(--text-body)",
      lineHeight: 1.55
    }
  }, r.text), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 700,
      color: "var(--text-strong)"
    }
  }, r.name)))))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--surface-sunken)",
      padding: "clamp(48px,6vw,80px) clamp(16px,4vw,48px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "640px",
      margin: "0 auto",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: "coral"
  }, "Daily Movement Club"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: "clamp(28px,3.5vw,40px)",
      margin: "16px 0 10px"
    }
  }, "Mehr Bewegung in dein Postfach"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--text-muted)",
      marginBottom: "24px"
    }
  }, "Inspiration, exklusive Aktionen und die neuesten Designs \u2014 direkt zu dir."), /*#__PURE__*/React.createElement("form", {
    onSubmit: e => e.preventDefault(),
    style: {
      display: "flex",
      gap: "10px",
      alignItems: "stretch",
      maxWidth: "440px",
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "du@beispiel.com",
    type: "email"
  })), /*#__PURE__*/React.createElement(Button, {
    type: "submit"
  }, "Dabei sein")))));
}
window.Home = Home;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/Home.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/Icons.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Ride Your Art — Icons
 * Lucide (MIT) icon paths, rendered React-native. The live Shopify store has
 * no custom icon font, so Lucide is the documented substitute: a clean 2px
 * stroke set that suits the friendly brand. 24×24 viewBox, round caps.
 */
function Svg({
  size = 22,
  stroke = "currentColor",
  strokeWidth = 2,
  children,
  style = {},
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      display: "inline-block",
      flex: "none",
      ...style
    }
  }, rest), children);
}
const Icon = {
  bag: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10a4 4 0 0 1-8 0"
  })),
  search: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 21-4.3-4.3"
  })),
  menu: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18h16"
  })),
  x: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M18 6 6 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6 12 12"
  })),
  heart: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
  })),
  arrowRight: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 5 7 7-7 7"
  })),
  plus: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14"
  })),
  minus: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  })),
  check: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M20 6 9 17l-5-5"
  })),
  truck: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18H9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "18",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "18",
    r: "2"
  })),
  instagram: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "20",
    x: "2",
    y: "2",
    rx: "5",
    ry: "5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "17.5",
    x2: "17.51",
    y1: "6.5",
    y2: "6.5"
  })),
  sparkles: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z"
  })),
  ruler: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 12.5 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 9.5 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 6.5 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 15.5 2-2"
  })),
  pin: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M12 17v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"
  })),
  leaf: p => /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"
  }))
};
window.Icon = Icon;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/Icons.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/ProductDetail.jsx
try { (() => {
/* global React */
// Ride Your Art — Product detail view.

function ProductDetail({
  product,
  onAdd,
  onBack
}) {
  const {
    Button,
    Badge,
    Rating,
    Chip
  } = window.RideYourArtDesignSystem_221a9a;
  const {
    Icon,
    Board
  } = window;
  const D = window.RYA_DATA;
  const p = product || D.products[0];
  const [surface, setSurface] = React.useState("kork");
  const [added, setAdded] = React.useState(false);
  const add = () => {
    onAdd(p);
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };
  return /*#__PURE__*/React.createElement("main", {
    style: {
      padding: "clamp(20px,3vw,40px) clamp(16px,4vw,48px) clamp(56px,6vw,88px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1100px",
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onBack,
    style: {
      background: "none",
      border: "none",
      cursor: "pointer",
      color: "var(--text-muted)",
      fontWeight: 600,
      fontSize: "14px",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      marginBottom: "22px",
      fontFamily: "var(--font-body)"
    }
  }, "\u2190 zur\xFCck zum Shop"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "48px",
      alignItems: "start"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--surface-sunken)",
      borderRadius: "var(--radius-xl)",
      height: "min(70vw, 560px)",
      padding: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, p.image ? /*#__PURE__*/React.createElement("img", {
    src: p.image,
    alt: p.name,
    style: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain"
    }
  }) : /*#__PURE__*/React.createElement(Board, {
    art: p.art
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "8px",
      marginBottom: "12px"
    }
  }, p.badge && /*#__PURE__*/React.createElement(Badge, null, p.badge), /*#__PURE__*/React.createElement(Badge, {
    tone: "soft"
  }, "Handmade in AT")), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: "clamp(36px,5vw,56px)",
      margin: "0 0 10px"
    }
  }, p.name), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "18px"
    }
  }, /*#__PURE__*/React.createElement(Rating, {
    value: p.rating,
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--text-muted)",
      fontSize: "14px",
      fontWeight: 600
    }
  }, p.rating.toFixed(1), " \xB7 ", p.reviews, " Bewertungen")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: "32px",
      color: "var(--text-strong)",
      marginBottom: "22px"
    }
  }, p.price), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "17px",
      color: "var(--text-body)",
      marginBottom: "24px",
      maxWidth: "440px"
    }
  }, "Ein Unikat, das Bewegung und Kunst verbindet. Inklusive ", /*#__PURE__*/React.createElement("strong", null, "MAGIC\xA0MOUNT"), " f\xFCr die Wand und Roller f\xFCrs Training."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "13px",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: ".08em",
      color: "var(--text-muted)",
      marginBottom: "10px"
    }
  }, "Oberfl\xE4che"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "10px"
    }
  }, D.surfaces.map(s => /*#__PURE__*/React.createElement(Chip, {
    key: s.id,
    active: surface === s.id,
    onClick: () => setSurface(s.id)
  }, s.label)))), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    full: true,
    onClick: add,
    iconLeft: added ? /*#__PURE__*/React.createElement(Icon.check, {
      size: 20
    }) : /*#__PURE__*/React.createElement(Icon.bag, {
      size: 20
    })
  }, added ? "Im Warenkorb!" : "In den Warenkorb"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      marginTop: "24px"
    }
  }, [{
    icon: "truck",
    t: "Versandkostenfrei ab 50€ · 🇦🇹 & 🇩🇪"
  }, {
    icon: "pin",
    t: "MAGIC MOUNT Wandhalterung inklusive"
  }, {
    icon: "ruler",
    t: "80 × 30 cm · Roller Ø 16 cm"
  }].map(row => {
    const I = Icon[row.icon];
    return /*#__PURE__*/React.createElement("div", {
      key: row.t,
      style: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontSize: "15px",
        color: "var(--text-body)"
      }
    }, /*#__PURE__*/React.createElement(I, {
      size: 18,
      style: {
        color: "var(--accent)"
      }
    }), " ", row.t);
  }))))));
}
window.ProductDetail = ProductDetail;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/ProductDetail.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/Shop.jsx
try { (() => {
/* global React */
// Ride Your Art — Shop / collection grid with filter chips.

function Shop({
  onOpenProduct
}) {
  const {
    ProductCard,
    Chip
  } = window.RideYourArtDesignSystem_221a9a;
  const D = window.RYA_DATA;
  const [filter, setFilter] = React.useState("all");
  const list = filter === "all" ? D.products : D.products.filter(p => p.collection === filter);
  return /*#__PURE__*/React.createElement("main", {
    style: {
      padding: "clamp(32px,4vw,56px) clamp(16px,4vw,48px) clamp(56px,6vw,88px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "1200px",
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "rya-eyebrow"
  }, "Shop"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: "clamp(34px,5vw,56px)",
      margin: "10px 0 6px"
    }
  }, "Alle Balance Boards"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--text-muted)",
      marginBottom: "28px"
    }
  }, list.length, " Designs \xB7 handgefertigt in \xD6sterreich"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
      marginBottom: "32px"
    }
  }, /*#__PURE__*/React.createElement(Chip, {
    active: filter === "all",
    onClick: () => setFilter("all")
  }, "Alle"), D.collections.map(c => /*#__PURE__*/React.createElement(Chip, {
    key: c.id,
    active: filter === c.id,
    onClick: () => setFilter(c.id)
  }, c.label))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      gap: "20px"
    }
  }, list.map(p => /*#__PURE__*/React.createElement(ProductCard, {
    key: p.id,
    name: p.name,
    price: p.price,
    badge: p.badge,
    rating: p.rating,
    reviews: p.reviews,
    image: p.image,
    artStyle: {
      background: p.art
    },
    onClick: () => onOpenProduct(p)
  })))));
}
window.Shop = Shop;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/Shop.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/data.js
try { (() => {
// Ride Your Art — storefront catalog (recreation data).
// Board art is rendered as on-brand abstract gradients because the original
// product photography is not bundled with this design system.

window.RYA_DATA = {
  collections: [{
    id: "feminine",
    label: "Feminine Energy"
  }, {
    id: "landscape",
    label: "Landscape"
  }],
  products: [{
    id: "floral",
    name: "Floral",
    collection: "feminine",
    price: "€229,00",
    badge: "Bestseller",
    rating: 4.9,
    reviews: 248,
    image: "../../assets/products/floral.png",
    art: "radial-gradient(circle at 32% 28%, #FBA360, #EF785A 55%, #C85539 100%)"
  }, {
    id: "moonshower",
    name: "Moonshower",
    collection: "feminine",
    price: "€229,00",
    badge: null,
    rating: 4.8,
    reviews: 132,
    image: "../../assets/products/moonshower.png",
    art: "linear-gradient(165deg, #FFE8D6 0%, #CDBFAC 45%, #6B705C 100%)"
  }, {
    id: "bed-of-plants",
    name: "Bed of Plants",
    collection: "feminine",
    price: "€229,00",
    badge: "Neu",
    rating: 5.0,
    reviews: 41,
    art: "linear-gradient(150deg, #B5AC99 0%, #6B705C 70%, #4E5343 100%)"
  }, {
    id: "dolomites",
    name: "Dolomites",
    collection: "landscape",
    price: "€229,00",
    badge: null,
    rating: 4.9,
    reviews: 187,
    image: "../../assets/products/dolomites.png",
    art: "linear-gradient(200deg, #FFE8D6 0%, #CDBFAC 40%, #B5AC99 70%, #6B705C 100%)"
  }, {
    id: "seceda",
    name: "Seceda",
    collection: "landscape",
    price: "€229,00",
    badge: "Bestseller",
    rating: 5.0,
    reviews: 96,
    image: "../../assets/products/seceda.png",
    art: "linear-gradient(190deg, #FBA360 0%, #EF785A 35%, #6B705C 100%)"
  }, {
    id: "forest",
    name: "Forest",
    collection: "landscape",
    price: "€229,00",
    badge: null,
    rating: 4.8,
    reviews: 73,
    image: "../../assets/products/forest.png",
    art: "linear-gradient(160deg, #6B705C 0%, #4E5343 60%, #2C2A26 100%)"
  }, {
    id: "attersee",
    name: "Attersee",
    collection: "landscape",
    price: "€229,00",
    badge: null,
    rating: 4.9,
    reviews: 58,
    image: "../../assets/products/attersee.png",
    art: "linear-gradient(180deg, #FFE8D6 0%, #B5AC99 50%, #6B705C 100%)"
  }, {
    id: "cabin",
    name: "Cabin",
    collection: "landscape",
    price: "€229,00",
    badge: "Neu",
    rating: 5.0,
    reviews: 29,
    image: "../../assets/products/cabin.png",
    art: "linear-gradient(155deg, #FBA360 0%, #CDBFAC 55%, #6B705C 100%)"
  }],
  reviews: [{
    name: "Lena M.",
    text: "Mein Board ist ein echter Eyecatcher im Wohnzimmer — und das Training nebenbei nehme ich gerne mit. 🤍",
    rating: 5
  }, {
    name: "Jonas K.",
    text: "Qualität top, die MAGIC MOUNT hält bombenfest. Hängt jetzt überm Sofa wie ein Kunstwerk.",
    rating: 5
  }, {
    name: "Sophie R.",
    text: "Hätte nie gedacht, dass ein Wackelbrett so schön sein kann. Bewege mich jeden Tag mehr.",
    rating: 5
  }],
  surfaces: [{
    id: "kork",
    label: "Kork"
  }, {
    id: "furnier",
    label: "Holz Furnier"
  }]
};
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/data.js", error: String((e && e.message) || e) }); }

__ds_ns.ProductCard = __ds_scope.ProductCard;

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.Chip = __ds_scope.Chip;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.Rating = __ds_scope.Rating;

})();
